import { useTranslation } from 'react-i18next';

const Gallery = ({ propiedad, ruta }) => {
    const { t } = useTranslation();

    const heroImages = propiedad.fotos_web;

    return (
        <div className="mb-6" id="galeria">
            <div className="mb-2 d-flex justify-content-end">
                <a className="btn btn-link d-none d-sm-flex" href="#"> {t("VER TODAS LAS IMÁGENES")}
                    <i className="fa-solid fa-arrow-right"></i>
                </a>
            </div>
            <div >
                <div className="c-home-gallery">
                    {heroImages.map((image, index) => (
                        <a className="item-gallery" data-src={`${ruta}/propiedades/${propiedad.id}/fotos/web/${image.nombre}`} key={image.id || index}>
                            <img src={`${ruta}/propiedades/${propiedad.id}/fotos/web/${image.nombre}`} alt={`${propiedad.nombre} - Slide ${index + 1}`} />
                        </a>
                    ))
                    }
                </div>
            </div>
            {/* <div className="d-flex justify-content-center">
                <a className="mt-2 btn btn-primary d-sm-none" href="#">{t("VER TODAS LAS IMÁGENES")}</a>
            </div>*/}
        </div>
    );
};

export default Gallery;
